// extracted by mini-css-extract-plugin
export default {"item":"row-item_item__fJYDk"};